import React, { Component } from 'react';

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

class DelayInput extends Component {
    constructor(props) {
        super();
        this.state = {
            value: props.value
        };
        this.triggerChange = this.triggerChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleKeyDown = this.handleKeyDown.bind(this)
    }

    componentWillMount() {
        this.timer = null;
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({ value: nextProps.value })
        }
    }
    handleChange(e) {
        clearTimeout(this.timer);

        this.setState({ value: e.target.value });

        this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
    }

    handleKeyDown(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerChange();
        }
    }

    triggerChange() {
        const { value } = this.state;

        this.props.onChange(value);
    }

    render() {
        const { refProp, className, placeholder, required } = this.props;

        return (
            <input
                ref={refProp}
                required={required}
                className={className}
                placeholder={placeholder}
                value={this.state.value}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
            />
        );
    }
}
export default DelayInput;




// WEBPACK FOOTER //
// ./src/components/common/DelayInput/index.jsx